import React, { useEffect, useState } from 'react';
import { Inventory, Variation, RestockItem } from '../../../@types/inventory';
import { getInventory, restockInventory } from '../../../backend-services';
import { useInventoryStore } from '../../../state/useInventoryStore';
import { EditInventoryForm } from '../restock/EditInventoryForm';
import { toast } from 'react-hot-toast';
import { CloseIcon } from '../../../assets/icons';
import BackArrow from '../../../assets/icons/backArrow';
import { convertToFloat } from '../../../utils/convertToFloat';
import { validateRestock } from '../../../modules/inventory/inventory';
import { Button } from '../../common';

interface RestockProps {
  setOpenModal: (show: boolean) => void;
  restockId: string | undefined;
}

const Restock = ({ restockId, setOpenModal }: RestockProps) => {
  const [inventories, setInventories] = useState<RestockItem>({
    id: restockId,
    name: '',
    rate: '',
    costPrice: '',
    quantity: '',
    date: '',
  });
  const [variationList, setVariationList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = React.useState({
    quantity: '',
    rate: '',
    costPrice: '',
  });

  const fetchInventoryItem = async (id: string) => {
    setIsLoading(true);
    try {
      const res = await getInventory(id);
      console.log(res);
      setInventories({
        ...inventories,
        name: res.name,
        rate: res.rate,
        costPrice: res.costPrice,
        quantity: res.quantity,
        date: res.createdAt,
      });
      setVariationList(res.variations);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error('Failed to fetch variations');
      console.error(error);
    }
  };

  const handleRestock = async () => {
    const newRate = convertToFloat(inventories.rate);
    const newQuantity = convertToFloat(inventories.quantity);
    const newCostPrice = convertToFloat(inventories.costPrice);

    const newVariationList = variationList.map((item: any) => ({
      ...item,
      price: convertToFloat(item.price),
      costPrice: convertToFloat(item.costPrice),
      quantity: convertToFloat(item.quantity),
    }));

    const { hasErrors, errors } = validateRestock({
      rate: newRate,
      quantity: newQuantity,
      costPrice: newCostPrice,
    });

    console.log(newQuantity, newCostPrice, newRate);
    if (hasErrors) {
      setError(errors);
      console.log(hasErrors, errors);
    } else {
      try {
        setIsLoading(true);
        const newInventory = {
          rate: newRate,
          costPrice: newCostPrice,
          quantity: newQuantity,
          variations: newVariationList,
        };
        console.log(newInventory);
        if (restockId) {
          console.log('five');
          const response = await restockInventory(restockId, newInventory);
          setIsLoading(false);
          setInventories({
            name: '',
            rate: '',
            quantity: '',
            costPrice: '',
            variations: [],
          });
          setOpenModal(false);
          toast.success('Inventory Restock was Successfully!');
        }
      } catch (error: any) {
        if (error.message === 'Inventory already exists') {
          toast(error.message);
        } else {
          console.log(error.message);
          toast('Unable to create inventory: ' + error.message);
        }
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (restockId) {
      fetchInventoryItem(restockId);
    }
  }, [restockId]);

  const { fetchVariations } = useInventoryStore((state) => ({
    fetchVariations: state.fetchVariation,
  }));

  const { variations } = useInventoryStore((state) => ({
    variations: state.variations,
  }));

  useEffect(() => {
    fetchVariations();
  }, [fetchVariations]);

  const cx =
    variationList.length > 0
      ? ''
      : 'fixed bottom-12 left-10 right-10 mb-34 flex gap-4 md:relative md:left-0 md:right-0 md:bottom-0'; 

  return (
    <div className="lg:px-[32px] md:px-[24px] relative">
      <div className="flex items-center justify-between mt-10 py-[7px] px-4">
        <div className="flex items-center w-full md:w-fit gap-4">
          <div className="" onClick={() => setOpenModal(false)}>
            <BackArrow />
          </div>
          <div className="flex justify-center w-full">
            <h1 className="text-[18] md:text-[24px] font-medium md:font-semibold">Restock</h1>
          </div>
        </div>
        <div className="hidden md:block" onClick={() => setOpenModal(false)}>
          <CloseIcon />
        </div>
      </div>
      <div className="mt-8 px-4 mb-8 space-y-3">
        <h1 className="text-[16px] font-medium">Product</h1>
        <p className="text-[20px] font-medium">{inventories.name}</p>
      </div>
      <EditInventoryForm
        inventory={inventories}
        variations={variationList}
        setVariations={setVariationList}
        setInventories={setInventories}
        variationList={variations}
      />

      <div className="hidden md:block mt-[24px] md:mt-[40px] border border-gray-300 px-[10px] mb-10 md:mb-6"></div>

      <div className="md:mt-6 px-4 md:flex md:justify-end">
        <div className=" l mb-34 flex gap-4 md:relative md:left-0 md:right-0 md:bottom-0">
          <button className="w-full bg-white rounded-[4px] md:w-[205px] text-black border border-[#044E97] text-center h-[48px] font-normal">
            Cancel
          </button>
          <button className="w-full bg-[#044E97] rounded-[4px] md:w-[205px] text-white border border-[#A4A4A4]  h-[48px] text-center font-normal">
            Save
          </button>
        </div>
      </div>
      <div className="mb-[44px]"></div>
    </div>
  );
};




export default Restock;
// fixed bottom-16 left-16 right-16 mb-34
// flex gap-4 w-full md:w-1/2 lg:absolute bottom-0
